import '../styles/Features.css'
import { FaSignal } from 'react-icons/fa'; // Font Awesome icon
import { FaPhoneVolume } from 'react-icons/fa'
import { FaTv } from 'react-icons/fa'
import { FaLightbulb } from 'react-icons/fa'

function Features() {
    return ( <
        section className = 'feature-section' id='feature-section'>
        <
        div >
        <
        h1 className = 'feature-h1' data-aos="zoom-in" data-aos-duration="800"> Our < span > Instant Services < /span> < /
        h1 >
        <
        span className = 'feature-sub-heading' data-aos="zoom-in" data-aos-duration="800"> Data | Airtime | TV Subscription | Electricity Bill Payment < /span> < /
        div >

        <
        div className = 'feature-lists flex flex-col lg:flex-row md:flex-row sm:flex-col '  >
        <
        div className = 'feature '  data-aos="fade-up" data-aos-duration="1000">
        <
        FaSignal className = 'feature-img' / >
        <
        b > Data < /b> <
        p >
        Low data rate with swift delivery
        for all networks <
        /p> <
        button > Buy Now < / button > < /
        div >

        <
        div className = 'feature' data-aos="fade-up" data-aos-duration="1050">
        <
        FaPhoneVolume className = 'feature-img' / >
        <
        b > Airtime < /b> <
        p >
        Never run low on airtime, purchase airtime
        for all networks instantly. < /p>  <
        button > Buy Now < /button > < /div >

        <
        div className = 'feature' data-aos="fade-up" data-aos-duration="1100">
        <
        FaTv className = 'feature-img' / >
        <
        b > TV Subscription < /b> <
        p >
        Stay connected!Subscribe and Renew your Tv subscription instantly. <
        /p> <button>Buy Now</button > < /
        div >

        <
        div className = 'feature' data-aos="fade-up" data-aos-duration="1150">
        <
        FaLightbulb className = 'feature-img' / >
        <
        b > Eletricity < /b> <
        p >
        Purchase prepaid meter tokens instantly and Pay estimated bill. <
        /p> <button>Buy Now</button > < /
        div >


        <
        /div> <
        div >
        <hr className = 'feature-hr feature-hr1' data-aos="fade-left" data-aos-duration="1200" / > 
        < hr className = 'feature-hr feature-hr2' data-aos="fade-right" data-aos-duration="1200" / > 
        < hr className = 'feature-hr feature-hr3' data-aos="fade-left" data-aos-duration="1200" / > <
        /div> < /
        section >
    );
}

export default Features;